import * as React from 'react';
import AppView from '~common/components/app-view/index';
import { Input, InputLabel, InputAdornment } from '@mui/material';
import { FormControl } from '@mui/material';
import { IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import { TextField } from '@mui/material';
import Renderers from '~common/lib/renderers';
import { Button } from '@mui/material';
import { Typography } from '@mui/material';
import { Paper } from '@mui/material';
import { Grid } from '@mui/material';

const styles = (theme: Theme): StyleRules => ({
	container: {
		// marginTop: 40,
		display: 'flex',
		justifyContent: 'center'
	},
	paper: {
		width: 740,
		padding: 30,
		backgroundColor: 'white'
	},
});



interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
}

type State = {
};

class NewUserCardRenderer extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {

		};
	}

	componentDidMount() {	
	}

    static register = () => {
        console.log("Registering NewUserCardRenderer")
        if(!Renderers.find("NewUserCardRenderer")){
            console.log("Registering NewUserCardRenderer")
            Renderers.register("NewUserCardRenderer", withStyles(styles)(NewUserCardRenderer))
        }
    }

	componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) { }




	render() {
		var self = this;
		const { classes }: { classes: ClassNameMap } = this.props;
		
		let returnValue = (
				<div className={classes.container}>
					<Paper className={classes.paper}>
						<Typography variant="h5" gutterBottom>
							New Users
						</Typography>
					<ul>
						<li><a style={{color:"blue"}} href="/users/self-register">Click here to register as a new user</a></li>
					</ul>
					</Paper>
				</div>
		);
        return returnValue
	}
}

export default withStyles(styles)(NewUserCardRenderer);